import axios from 'axios';
import { CustomAxiosRequestConfig } from 'core/utils/axios';

interface AuthResponse {
    token: string;
}

/**
 * Sign in
 * @param login
 * @param password
 * @returns
 */
export function authenticate(login: string, password: string, idSousWeb?: string, customConfig?: CustomAxiosRequestConfig): Promise<AuthResponse> {
    let requestData: { login: string; password: string; idSousWeb?: string } = {
        login,
        password,
    };

    if (idSousWeb !== undefined && idSousWeb !== '') {
        requestData.idSousWeb = idSousWeb;
    }

    const config: CustomAxiosRequestConfig = {
        ...customConfig, // Merge custom configuration with default configuration
    };

    return axios.post<AuthResponse, AuthResponse>('/auth', requestData, config);
}

/**
 * Change password
 * @param payload
 * @returns
 */
export function resetPassword({ token, password }) {
    return axios.post<any>('/auth/reset_password', {
        token,
        password,
    });
}

/**
 * Request mail to change password
 * @param param0
 * @returns
 */
export function getMailToResetPassword({ email }) {
    return axios.post<any>('/auth/send_email_to_reset_password', { email });
}

/**
 * Validate token to reset password
 * @param param0
 * @returns
 */
export async function getTokenValidity({ token }) {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/validate_token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token }),
        });

        if (!response.ok) {
            const errorMessage = await response.text();
            throw new Error(errorMessage);
        }

        return await response.json();
    } catch (error) {
        const msg = JSON.parse(error.message);
        throw new Error(msg.message);
    }
}
